import { IConfigFileScript } from "types/config-files/mainConfig";
import { IServiceListProps } from "../ServiceList";
import { VENDORS_FILTER_CATEGORIES } from "constants/vendors";
import { VendorTypes } from "helpers/tcf/TCFConsentProvider/types";

const filterServiceListVendors = ({
  filterCategories,
  searchPhrase,
  scripts,
}: IServiceListProps & { scripts: IConfigFileScript[] }) => {
  // Check if entire filter for services is disabled
  const catFilter = filterCategories.find(
    (cat) => cat.id === VENDORS_FILTER_CATEGORIES
  );

  if (catFilter) {
    if (
      !catFilter.values.find(
        (item) => item.id === VendorTypes.NON_IAB && item.isVisible
      )
    ) {
      return [];
    }
  }

  if (searchPhrase !== "") {
    scripts = scripts.filter((scripts) => {
      return scripts.name.toLowerCase().includes(searchPhrase.toLowerCase());
    });
  }

  return scripts;
};

export default filterServiceListVendors;
